import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {NylasEnvironment, NylasState} from '@store/@types/nylas/NylasIntegration';
import {NylasIntegrationSource} from '@store/nylas/NylasIntegrationSource';

interface AsyncActions {
  // Fetch global nylas settings for all accounts
  fetchNylasEnvironment(): Promise<NylasEnvironment>;
  // Fetch sessionUser's nylas email
  fetchCalendarEmail(): Promise<string>;
  // Fetch state of sessionUser's nylas oauth
  fetchNylasState(): Promise<NylasState>;
  // Delete current nylas settings for sessionUser
  forgetNylasConnection(): Promise<void>;
}

interface SyncActions {}

export interface NylasIntegrationActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class NylasIntegrationActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      ...generateAsyncActions<AsyncActions>(
        'fetchCalendarEmail',
        'fetchNylasEnvironment',
        'fetchNylasState',
        'forgetNylasConnection'
      )
    );
  }

  fetchNylasEnvironment() {
    return dispatch => {
      dispatch();
      return NylasIntegrationSource.fetchNylasEnvironment().then(
        this.fetchNylasEnvironmentSuccess,
        this.fetchNylasEnvironmentError
      );
    };
  }

  fetchNylasState() {
    return dispatch => {
      dispatch();
      return NylasIntegrationSource.fetchNylasState().then(
        this.fetchNylasStateSuccess,
        this.fetchNylasStateError
      );
    };
  }

  forgetNylasConnection() {
    return dispatch => {
      dispatch();
      return NylasIntegrationSource.forgetNylasConnection()
        .then()
        .then(this.forgetNylasConnectionSuccess, this.forgetNylasConnectionError);
    };
  }

  fetchCalendarEmail() {
    return dispatch => {
      dispatch();
      return NylasIntegrationSource.fetchCalendarEmail().then(
        this.fetchCalendarEmailSuccess,
        this.fetchCalendarEmailError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(NylasIntegrationActions);
